export const pageName = {
  dashboard: {
    common: "Dashboard",
    task: "Your Task Dashboard",
    assignedToMePendingTask: "Pending Task (Assigned To Me)",
    assignedToMeAcceptedTask: "Accepted Task (Assigned To Me)",
    assignedByMePendingTask: "Pending Task (Assigned By Me)",
    assignedByMeAcceptedTask: "Accepted Task (Assigned By Me)",
    mobAssignedToMePendingTask: "To Me(Pending)",
    mobAssignedToMeAcceptedTask: "To Me(Accepted)",
    mobAssignedByMePendingTask: "By Me(Pending)",
    mobAssignedByMeAcceptedTask: "By Me(Accepted",
    completedTask: "Completed Task",
    project: "Project Dashboard",
    projectProduct: "Selected Project's Products Tasks",
    pendingTask: "Pending Task",
    acceptedTask: "Accepted Task",
    allTask: "Team's Task",
  },
  admin: {
    users: {
      addUser: "Add New User",
      updateUser: "Update User",
      usersList: "Users",
      updatePermission:
        "Update Permission [1-read, 2-write, 4-approval, 8-admin, 16-viewAll]",
    },
    userTask: {
      filter: "User Filter",
      records: "User's Task in hand",
    },
  },
  general: {
    addComment: "Add Comment",
  },
  //dummy pageNames
  enquiry: {
    newEnquiry: "New Enquiry",
    updateEnquiry: "Update Enquiry",
    equityList: "Enquiry",
    previewEnquiry: "Preview",
    task: "Task for Enquiry",
  },
  project: {
    projectList: "Projects",
    task: "Task for Project",
    update: "Update Project Deadline",
  },
  product: {
    productList: "Product",
    task: "Task for Product",
    newProduct: "New Product",
    updateProduct: "Update Product",
    previewProduct: "Product Preview",
    assignPmc: "Assign PMC",
    pmcHandover: "PMC Handover Checklist",
    executionTimeline: "Product Execution Timeline",
    editExecutionTimeline: "Edit Product Execution Timeline",
    inputOutputModal: "I/O For Product Execution Timeline",
  },
  task: {
    tasklist: "Tasks",
    newTask: "New Task",
    updateTask: "Update Task",
    acceptTask: "Accept Task",
    rejectTask: "Reject Task",
    updateTaskTo: "Assign/Reassign Task",
    doneStatusOutput: "Task Output",
  },
  finish: {
    list: "Finish Codes",
    newFinish: "Add Finish Code",
    updateFinish: "Update Finish Code",
  },
};
